<template>
  <div>
    <div class="index" v-bind:style="{backgroundImage:'url(' + bg_img + ')'}">
        <div ref='title'>
          <h3 class="title">认识我们，</h3>
          <h3><span>你, </span>准备好了吗？</h3>
        </div>
        <div ref="button" @click="goNext()" class="button-bg" v-bind:style="{backgroundImage:'url(' + button_click + ')'}">
            GO
        </div>
          <img ref="img" class="index-bottom" src="https://cdn.hanlandglobal.com/h5-index-bg.png" />
    </div>
    <div v-if="loading" class="loading">
      <img class="loading_img" :src="loading_img" />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import bg_img from '../assets/image/h5-bg.png'
import button_click from '../assets/image/button-click.gif'
import loading_img from '../assets/image/timg.gif'

export default {
  name: 'Home',
  data(){
    return {
      bg_img,button_click,
      loading_img,
      loading:true
    }
  },
  mounted(){
    setTimeout(()=>{
      this.loading = false
    },2400)
  },
  methods:{
    goNext:function(){
      this.$refs.img.className = 'animated fadeOutDown'
      this.$refs.title.className = 'animated fadeOutUp'
      this.$refs.button.className = 'button-bg animated fadeOutRight'
      setTimeout(()=>{
        this.$router.push('/whoUS')
      },600)
    },
  }
}
</script>
<style lang='scss' scoped>
.index{
  width: 100%;
  height: 100vh;
  background-repeat: no-repeat;
  background-size: 100% 100vh;
  position: relative;
}
h3{
  font-size: 0.54rem;
  font-family: SourceHan;
  color: #4d372e;
  padding-left: 1.17rem;
  text-align: left;
  letter-spacing: 1px;
  span{
    font-size: 0.72rem;
  }
}
.title{
  padding-top:13.6vh;
}
.index-bottom{
  width: 100%;
  height: 6.26rem;
  position: absolute;
  left: 0;
  bottom: 0;
}
.button-bg{
  width: 2.7rem;
  height: 1.98rem;
  background-repeat: no-repeat;
  background-size: 2.7rem 1.98rem;
  margin:0 auto;
  color: #f8eed5;
  font-size: 0.36rem;
  line-height: 1.34rem;
  margin-top: 6vh;
  font-family: SourceHan;
}
.loading{
  position: fixed;
  top:0;
  background: #fff;
  width: 100%;
  height: 100vh;
}
.loading_img{
  width: 1.6rem;
  height: 1.6rem;
  position: absolute;
  top:50%;
  bottom:50%;
  right: 50%;
  left: 50%;
  margin-left: -0.8rem;
  margin-top:-0.8rem;
}
</style>
